<combo-search-select *ngIf="aluno"
                     nome="tiposPublicosPrioritarios"
                     [label]="label"
                     placeholder="Selecione os tipos de públicos prioritários"
                     placeholderPesquisa="Pesquise um tipo de público prioritário..."
                     [itens]="tiposPublicosPrioritarios"
                     itemId="id"
                     itemDescricao="descricao"
                     [showDisplayId]="showDisplayId"
                     [obrigatorio]="false"
                     [desabilitado]="false"
                     [multiplaSelecao]="true"
                     [valor]="aluno.tiposPublicosPrioritarios"
                     (valorChange)="onValorChange($event)">
</combo-search-select>
